var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tools02-report-asp"},[_c('el-row',[_c('el-col',[_c('h2',[_vm._v("ASPごとの成果データのダウンロード方法")])])],1),_c('Tools02CsvManualLinksManualLinks')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }